import { Link, useLocation } from "react-router-dom";

export const Header = ({ transparent = false }) => {
  const loc = useLocation();
  const onLanding = loc.pathname === "/";
  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 w-full border-b border-[#eae4d9]/70 backdrop-blur-md ${
        transparent ? "bg-[#fdfbf7]/70" : "bg-[#fdfbf7]/90"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-2 group"
        >
          <img
            src="/logo-header.png"
            alt="GroomingPreview.ai"
            width="36"
            height="36"
            data-testid="header-logo-mark"
            className="w-9 h-9 object-contain group-hover:rotate-[-8deg] transition-transform"
          />
          <span className="font-display font-extrabold text-lg tracking-tight text-[#0f172a]">
            GroomingPreview<span className="text-[#ff6b4a]">.</span>ai
          </span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-3">
          {onLanding ? (
            <>
              <a
                href="#how-it-works"
                data-testid="nav-how-it-works"
                className="hidden sm:inline-flex px-3 py-2 text-sm font-medium text-[#1e293b] hover:text-[#0f172a]"
              >
                How it works
              </a>
              <a
                href="#styles"
                data-testid="nav-styles"
                className="hidden sm:inline-flex px-3 py-2 text-sm font-medium text-[#1e293b] hover:text-[#0f172a]"
              >
                Styles
              </a>
              <a
                href="#pricing"
                data-testid="nav-pricing"
                className="hidden sm:inline-flex px-3 py-2 text-sm font-medium text-[#1e293b] hover:text-[#0f172a]"
              >
                Pricing
              </a>
              <Link
                to="/dogs"
                data-testid="nav-my-dogs"
                className="hidden sm:inline-flex px-3 py-2 text-sm font-medium text-[#1e293b] hover:text-[#0f172a]"
              >
                My Dogs
              </Link>
              <Link
                to="/studio"
                data-testid="nav-try-free"
                className="inline-flex items-center gap-2 rounded-full bg-[#ff6b4a] hover:bg-[#e85535] text-white text-sm font-semibold px-4 py-2.5 shadow-md shadow-[#ff6b4a]/25 transition-all active:scale-[0.98]"
              >
                Try It Free
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/dogs"
                data-testid="nav-my-dogs"
                className="hidden sm:inline-flex items-center gap-2 rounded-full bg-white text-[#0f172a] text-sm font-medium px-4 py-2.5 border border-[#eae4d9] hover:bg-[#f3efe6] transition"
              >
                My Dogs
              </Link>
              <Link
                to="/"
                data-testid="nav-back-home"
                className="inline-flex items-center gap-2 rounded-full bg-white text-[#0f172a] text-sm font-medium px-4 py-2.5 border border-[#eae4d9] hover:bg-[#f3efe6] transition"
              >
                ← Home
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
